import { SET_OCCASIONS_LIST } from "./types";
import backend, { recursiveRequest } from "../apis/backend";
import errorHandler from "../helpers/errorHandler";
import store from "../store";

export const getOccasions = () => async (dispatch) => {
    try {
        const response = await recursiveRequest(async () => {
            return await backend.get(`/api/occasions`, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${store.getState().auth.token || ""}`
                }
            });
        });

        if (response) {
            dispatch({ type: SET_OCCASIONS_LIST, payload: response.data.list });
        };
    }
    catch (error) { errorHandler(error, null); }
};